import CodeSplitEnvWrapper from '../common/env/CodeSplitEnvWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const PlanBuilderCTAsContainer = props => {
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */'pricing-pages-ui/components/plan-builder/PlanBuilderAuthedCtas'),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */'pricing-pages-ui/components/plan-builder/PlanBuilderPublicCtas'),
    authedComponentProps: Object.assign({}, props),
    publicComponentProps: Object.assign({}, props)
  });
};
export default PlanBuilderCTAsContainer;